import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { DeleteCampaign } from '../api';
import { useInvalidateAllCampaigns } from './use-invalidate-all-campaigns';

export const useDeleteCampaignMutation = () => {
  const invalidateAllCampaigns = useInvalidateAllCampaigns();

  const deleteCampaignMutation = useMutation({
    mutationFn: (campaignId: string) => DeleteCampaign(campaignId),
    onSuccess: async () => {
      await invalidateAllCampaigns();
      toast.success('Campaign deleted.');
    },
    onError: () => {
      toast.error('Failed to delete campaign. Please try again.');
    },
  });

  return deleteCampaignMutation;
};
